// @flow
import type { Baggage } from "booking/services/baggage/types"

type LoadSuccessBaggage = {|
  type: "LOAD_SUCCESS_BAGGAGE",
  payload: Baggage,
|}

export type Action = LoadSuccessBaggage

// Actions
// ===
// eslint-disable-next-line import/prefer-default-export
export const loadSuccessBaggage = (baggage: Baggage): LoadSuccessBaggage => ({
  type: "LOAD_SUCCESS_BAGGAGE",
  payload: baggage,
})
